// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.store("cartDrawerStore", {
    products: Alpine.$persist([]),
    cartDrawerSectionId: "",
    sellingPlan: Alpine.$persist(null),
    dynamicBoxId: Alpine.$persist(null),
    dynamicBoxSelectableProductVariants: Alpine.$persist([]),
    isWholesaleCustomer: Alpine.$persist(false),
    isSubscriptionActive: Alpine.$persist(false),
    /**
     * @param {string | number | null} sellingPlanId
     */
    setSellingPlan(sellingPlanId) {
      this.sellingPlan = Number(sellingPlanId) || null;
    },
    setIsWholesaleCustomer(isWholesaleCustomer) {
      this.isWholesaleCustomer = isWholesaleCustomer;

      if (isWholesaleCustomer) {
        this.sellingPlan = null;
        this.dynamicBoxId = null;
        this.dynamicBoxSelectableProductVariants = [];
      }
    },
    setDynamicBoxId(dynamicBoxId) {
      this.dynamicBoxId = dynamicBoxId;
    },
    setDynamicBoxSelectableProductVariants(dynamicBoxSelectableProductVariants) {
      this.dynamicBoxSelectableProductVariants = dynamicBoxSelectableProductVariants;
    },
    updateProducts(products) {
      this.products = products;
    },
  });
  /**
   * @param {{sellingPlans: Array<{id: number | null, name: string}>, sectionId: string, bundleProductId: string, bundleProductAvailableVariantId: string}} component
   */
  Alpine.data(
    "cartDrawer",
    function ({
      sellingPlans = [],
      sectionId = "",
      bundleProductId = null,
      bundleProductAvailableVariantId = null,
      isWholesaleCustomer = false,
    }) {
      return {
        sellingPlans: [...sellingPlans].filter(plan => !/[56]\s*week/i.test(plan.name)),
        // Removed benefitsActive since benefits are always shown when subscription is active
        sectionId,
        /** @type {Array<{id: number, quantity: number, sellingPlan: number | null}>} */
        cartProducts: Alpine.$persist([]),
        /** @type {Array<{id: number}>} */
        cartProductsWithoutAvailableSellingPlans: [],
        _reconciling: false,
        isWholesaleCustomer: isWholesaleCustomer === "true",
        bundleProductId,
        bundleProductAvailableVariantId,

        init() {
          this.$store.cartDrawerStore.setIsWholesaleCustomer(
            this.isWholesaleCustomer
          );
          this.$store.cartDrawerStore.cartDrawerSectionId = sectionId;
          this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());

          // Reconcile the subscribe toggle with the real cart state on load.
          this.reconcileSubscriptionState();

          // Ensure a valid default frequency: covers fresh visitors (null) and
          // persisted selections that are no longer offered (e.g. 5/6 week plans)
          const storedPlan = this.$store.cartDrawerStore.sellingPlan;
          const storedPlanAvailable = storedPlan && this.sellingPlans.some(plan => plan.id === Number(storedPlan));
          if (this.$store.cartDrawerStore.isSubscriptionActive && !storedPlanAvailable) {
            this.$store.cartDrawerStore.setSellingPlan(this.getDefaultSellingPlan());
          }

          if (bundleProductId && bundleProductAvailableVariantId) {
            this.updateDynamicBox(bundleProductId, bundleProductAvailableVariantId);
          }

          window.addEventListener('cart-drawer-store:update', this.handleCartStoreUpdate.bind(this));
          window.addEventListener('cart-drawer-store:show-notification', this.displayNotification);
          window.addEventListener('cart-drawer-store:reorder-selling-plans', this.handleReorderSellingPlans.bind(this));
          window.addEventListener('cart-drawer-store:sync-subscription', this.handleSyncSubscription.bind(this));
        },

        /**
         * Destroys the cart drawer alpine component.
         */
        destroy() {
          window.removeEventListener('cart-drawer-store:update', this.handleCartStoreUpdate);
          window.removeEventListener('cart-drawer-store:show-notification', this.displayNotification);
          window.removeEventListener('cart-drawer-store:reorder-selling-plans', this.handleReorderSellingPlans);
          window.removeEventListener('cart-drawer-store:sync-subscription', this.handleSyncSubscription);
        },

        handleCartStoreUpdate(event) {
          this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());
          // Re-check on every cart change, not just on load: emptying the cart
          // must wipe the persisted subscription, and a new item added to an
          // already-subscribed cart must adopt that cart's frequency.
          this.reconcileSubscriptionState();
        },

        /**
         * Keep the whole cart's subscription state consistent with its contents.
         * - Empty cart: full reset (toggle off, no stored plan) so a persisted
         *   ($persist) subscription can't bleed into the next cart.
         * - Cart with a subscribed line: toggle on, adopt that line's plan, and
         *   pull any other eligible line onto it so a newly added product matches
         *   the subscription already in the cart.
         * - Cart with only one-time items: toggle off, clear the stored plan.
         */
        reconcileSubscriptionState() {
          if (this._reconciling) return;

          const cartLines = this.$store.cartDrawerStore.products || [];

          // Nothing in the cart -> wipe any persisted subscription entirely.
          if (cartLines.length === 0) {
            this.$store.cartDrawerStore.isSubscriptionActive = false;
            this.$store.cartDrawerStore.setSellingPlan(null);
            return;
          }

          const subscribedLine = cartLines.find(
            (p) => p && p.selling_plan_allocation && p.selling_plan_allocation.selling_plan && p.selling_plan_allocation.selling_plan.id
          );

          // No subscribed line (or wholesale) -> one-time cart, toggle off.
          if (!subscribedLine || this.$store.cartDrawerStore.isWholesaleCustomer) {
            this.$store.cartDrawerStore.isSubscriptionActive = false;
            this.$store.cartDrawerStore.setSellingPlan(null);
            return;
          }

          // A subscription exists in the cart: adopt its plan cart-wide.
          this.$store.cartDrawerStore.isSubscriptionActive = true;
          const planId = Number(subscribedLine.selling_plan_allocation.selling_plan.id);
          if (this.sellingPlans.some((plan) => plan.id === planId)) {
            this.$store.cartDrawerStore.setSellingPlan(planId);
          }

          // Pull any eligible line that isn't already on this plan (a product just
          // added one-time, or on a different frequency) onto the cart's plan.
          this.cartProductsWithoutAvailableSellingPlans =
            this.parseCartProductsIdsWithoutSellingPlansJSON();
          const eligibleLines = cartLines.filter((p) => {
            if (!p) return false;
            if (this.cartProductsWithoutAvailableSellingPlans.includes(p.id)) return false;
            if (this.cartProductsWithoutAvailableSellingPlans.includes(p.variant_id)) return false;
            if (p.discounted_price === 0) return false;
            return true;
          });
          const allOnPlan = eligibleLines.every(
            (p) => Number(p.selling_plan_allocation?.selling_plan?.id) === planId
          );
          if (!allOnPlan) {
            this._reconciling = true;
            Promise.resolve(this.updateCartItems()).finally(() => {
              this._reconciling = false;
            });
          }
        },

        /**
         * Handle subscription sync from Build Your Box or Quick Shop
         * @param {CustomEvent} event - Event with isSubscriptionActive, sellingPlan, and source in detail
         */
        handleSyncSubscription(event) {
          const { isSubscriptionActive, sellingPlan, source } = event.detail || {};
          
          // Ignore events dispatched by the cart drawer itself to prevent double updates
          if (source === "cart-drawer") return;
          
          console.log("Syncing subscription:", { isSubscriptionActive, sellingPlan, source });
          
          // Update isSubscriptionActive (persisted in Alpine data)
          this.$store.cartDrawerStore.isSubscriptionActive = isSubscriptionActive;
          
          // Update sellingPlan in store (already done in box-builder, but ensure consistency)
          if (isSubscriptionActive && sellingPlan) {
            this.$store.cartDrawerStore.setSellingPlan(sellingPlan);
          } else if (!isSubscriptionActive) {
            this.$store.cartDrawerStore.setSellingPlan(null);
          }

          this.updateCartItems();
        },

        get totalPrices() {
          const totalPrices = {
            otp: 0,
            subscription: 0,
          };
  
          // Calculate base price (one-time purchase price)
          const otpPrice = this.$store.cartDrawerStore.products.reduce((total, item) => {
            // Use compare_at_price from selling plan allocation if available (original price)
            // Otherwise use original_line_price
            const price = item.selling_plan_allocation?.compare_at_price 
              ? item.selling_plan_allocation.compare_at_price * item.quantity
              : item.original_line_price;
            return total + price;
          }, 0);
  
          totalPrices.otp = otpPrice;
          // 10% discount for subscription
          totalPrices.subscription = Math.round(otpPrice * 0.9);
  
          return totalPrices;
        },

        updateDynamicBox(bundleProductId, bundleProductAvailableVariantId) {
          if (!bundleProductId || !bundleProductAvailableVariantId) return;
          if (this.$store.cartDrawerStore.dynamicBoxSelectableProductVariants?.length > 0) return;

          fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
            method: 'POST',
            body: JSON.stringify({ "productPlatformId": bundleProductId }),
              headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }).then((data) => data.json()).then(({ DynamicBox }) => {
            const selectableProductVariants = DynamicBox.selectableProductVariants.flatMap(p => 
              p.productVariants.map(v => 
                +v.platformId.replace('gid://shopify/ProductVariant/', '')
              ));

            this.$store.cartDrawerStore.setDynamicBoxSelectableProductVariants(selectableProductVariants);
                this.$store.cartDrawerStore.setDynamicBoxId(DynamicBox.boxId);
          })
        },
        /**
         * @returns {Array<{id: number, quantity: number, sellingPlan: number | null}>}
         */
        parseCartProductsJSON() {
          try {
            const cartProductsTemplate = this.$root.querySelector(
              ".cart-products-template"
            );
            if (!cartProductsTemplate) return [];
            return JSON.parse(cartProductsTemplate.textContent);
          } catch (error) {
            console.error("Error parsing cart products JSON:", error);
            return [];
          }
        },

        /**
         * @returns {Array<{id: number}>}
         */
        parseCartProductsIdsWithoutSellingPlansJSON() {
          try {
            const cartProductsTemplate = this.$root.querySelector(
              ".cart-products-without-selling-plans-template"
            );
            if (!cartProductsTemplate) return [];
            const ids = JSON.parse(cartProductsTemplate.textContent).map(
              /** @param {string} id */
              (id) => Number(id)
            );
            return ids;
          } catch (error) {
            console.error("Error parsing cart products JSON:", error);
            return [];
          }
        },

        /**
         * Returns the preselected selling plan ID if valid, then the 4-week plan, otherwise falls back to first.
         * @returns {number | null}
         */
        getDefaultSellingPlan() {
          const preselectedId = window.preselectedSellingPlan;

          if (preselectedId) {
            const found = this.sellingPlans.find(plan => plan.id === Number(preselectedId));
            if (found) return found.id;
          }

          const fourWeek = this.sellingPlans.find(plan => /4\s*week/i.test(plan.name));
          if (fourWeek) return fourWeek.id;

          return this.sellingPlans[0]?.id;
        },

        onToggleSubscription() {
          if (!this.$store.cartDrawerStore.isSubscriptionActive || this.$store.cartDrawerStore.isWholesaleCustomer) {
            this.$store.cartDrawerStore.setSellingPlan(null);
            this.updateCartItems();
          } else {
            this.$store.cartDrawerStore.setSellingPlan(this.getDefaultSellingPlan());
            this.updateCartItems();
          }

          // Dispatch sync event to notify sidebar (with source to prevent self-handling)
          window.dispatchEvent(
            new CustomEvent("cart-drawer-store:sync-subscription", {
              detail: {
                isSubscriptionActive: this.$store.cartDrawerStore.isSubscriptionActive,
                sellingPlan: this.$store.cartDrawerStore.sellingPlan,
                source: "cart-drawer",
              },
            })
          );
        },

        /**
         * @param {Event} event
         */
        onChangeCartFrequency(event) {
          if (!(event.target instanceof HTMLSelectElement)) return;

          if (this.$store.cartDrawerStore.isWholesaleCustomer) {
            this.$store.cartDrawerStore.setSellingPlan(null);
            this.updateCartItems();
            return;
          }

          this.$store.cartDrawerStore.setSellingPlan(
            Number(event.target.value) || null
          );

          this.updateCartItems();

          // Dispatch sync event to notify sidebar (with source to prevent self-handling)
          window.dispatchEvent(
            new CustomEvent("cart-drawer-store:sync-subscription", {
              detail: {
                isSubscriptionActive: this.$store.cartDrawerStore.isSubscriptionActive,
                sellingPlan: this.$store.cartDrawerStore.sellingPlan,
                source: "cart-drawer",
              },
            })
          );
        },

        /**
         * @returns {string}
         */
        getBody() {
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          let cartItemComponentsSectionIds = [];

          cartItemsComponents.forEach((item) => {
            if (item instanceof HTMLElement && item.dataset.sectionId) {
              cartItemComponentsSectionIds.push(item.dataset.sectionId);
            }

            cartItemComponentsSectionIds.push(item.dataset.sectionId);
          });

          const sectionsToUpdate = new Set(cartItemComponentsSectionIds);

          this.$store.cartDrawerStore.updateProducts(this.parseCartProductsJSON());

          const products = this.$store.cartDrawerStore.products;

          this.cartProductsWithoutAvailableSellingPlans =
            this.parseCartProductsIdsWithoutSellingPlansJSON();
          const itemsToUpdate = products.map(
            /** @param {{id: number, sellingPlan: number|undefined, quantity: number}} product */
            (product) => {
              const isDiscount = product.discounted_price === 0;
              if (
              this.cartProductsWithoutAvailableSellingPlans.includes(product.id) || this.cartProductsWithoutAvailableSellingPlans.includes(product.variant_id) || isDiscount
              ) {
                return {
                  id: product.id,
                  quantity: product.quantity,
                  properties: {
                    // _sellingPlanIgnore: true,
                  },
                };
              }
            const isDynamicBoxEnabled = this.$store.cartDrawerStore.dynamicBoxId ? true : false;
            const isBundleVariant = this.$store.cartDrawerStore.dynamicBoxSelectableProductVariants.includes(product.id);

              return {
                id: product.id,
                quantity: product.quantity,
                selling_plan: this.$store.cartDrawerStore.sellingPlan,
                properties: {
                ...(isDynamicBoxEnabled && isBundleVariant && this.$store.cartDrawerStore.sellingPlan && {
                      _dynamicBoxIndex: 0,
                      _dynamicBoxId: this.$store.cartDrawerStore.dynamicBoxId,
                })
                },
              };
            }
          );

          const body = JSON.stringify({
            items: itemsToUpdate,
            sections: Array.from(sectionsToUpdate).join(","),
          });

          return body;
        },

        async updateCartItems() {
          this.disableCartItems();

          try {
            // @ts-ignore
            const clearResponse = await fetch(Theme.routes.cart_clear_url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            });
            const clearResponseText = await clearResponse.text();
            
            // Second: Add items after clearing is complete
            const addResponse = await fetch(
              `${Theme.routes.cart_add_url}`,
              window.fetchConfig("json", {
                body: this.getBody(),
              })
            );
            const addText = await addResponse.text();
            const parsedResponseText = JSON.parse(addText);

            if (parsedResponseText.errors) {
              // Handle errors
              console.error("Error adding items:", parsedResponseText.errors);
              return;
            }
            // Process the successful response

            const newSectionHTML = new DOMParser().parseFromString(
              parsedResponseText.sections[this.sectionId],
              "text/html"
            );
            // todo: use alpine x-ref instead
            const newCartHiddenItemCount = newSectionHTML.querySelector(
              '[ref="cartItemCount"]'
            )?.textContent;
            const newCartItemCount = newCartHiddenItemCount
              ? parseInt(newCartHiddenItemCount, 10)
              : 0;

            window.dispatchEvent(
              // @ts-ignore
              new CartUpdateEvent({}, this.sectionId, {
                itemCount: newCartItemCount,
                source: "cart-items-component",
                sections: parsedResponseText.sections,
              })
            );

            // Morph ALL sections that were returned, not just the cart drawer
            // This ensures quick shop sidebar and other cart-items-components are updated
            const sectionsToMorph = Object.keys(parsedResponseText.sections || {});
            sectionsToMorph.forEach((sectionId) => {
              // @ts-ignore
              morphSection(sectionId, parsedResponseText.sections[sectionId]);
            });

          window.dispatchEvent(new CustomEvent('cart-drawer-store:update'));
          } catch (error) {
            console.error("Error clearing cart:", error);
          } finally {
            this.enableCartItems();
          }
        },
        /**
         * Disables the cart items.
         */
        disableCartItems() {
          const cartItemsComponents = document.querySelectorAll(
            "cart-items-component"
          );
          cartItemsComponents.forEach((item) => {
            if (item instanceof HTMLElement) {
              item.classList.add("cart-items-disabled");
            }
          });
        },

        /**
         * Enables the cart items.
         */
        enableCartItems() {
          const cartItemsComponents = document.querySelectorAll(
            "cart-items-component"
          );
          cartItemsComponents.forEach((item) => {
            if (item instanceof HTMLElement) {
              item.classList.remove("cart-items-disabled");
            }
          });
        },
        // @ts-ignore
        morphCart(sectionId, html, reject) {
          const fragment = new DOMParser().parseFromString(html, "text/html");
          const existingElement = document.getElementById(
            // @ts-ignore
            buildSectionSelector(sectionId)
          );
          const newElement = fragment.getElementById(
            // @ts-ignore
            buildSectionSelector(sectionId)
          );

          if (!existingElement) {
            throw new Error(`Section ${sectionId} not found`);
          }

          if (!newElement) {
            throw new Error(
              `Section ${sectionId} not found in the section rendering response`
            );
          }

          // @ts-ignore
          morph(existingElement, newElement, reject);
        },

        /**
         * Handles the reorder selling plans event.
         * @param {Event} event
         */
        handleReorderSellingPlans(event) {
          if (!event.detail?.sellingPlans) return;
          this.reorderSellingPlans(event.detail?.sellingPlans);
        },

        /**
         * Reorders the selling plans in the cart drawer.
         * @param {Array<number>} sellingPlansIdsArray
         */
        reorderSellingPlans(sellingPlansIdsArray = []) {
          // If we have ids, we need to follow the order of the ids, if there is not id in the array we need to add it to the end
          if (!Array.isArray(sellingPlansIdsArray) || sellingPlansIdsArray.length === 0) return;
        
          this.sellingPlans = [...this.sellingPlans].sort((a, b) => {
            const indexA = sellingPlansIdsArray.indexOf(a.id);
            const indexB = sellingPlansIdsArray.indexOf(b.id);
        
            // If both are not in idsArray, maintain original order
            if (indexA === -1 && indexB === -1) return 0;
            // If a is not in idsArray, move it to the end
            if (indexA === -1) return 1;
            // If b is not in idsArray, move it to the end
            if (indexB === -1) return -1;
            // Both are in idsArray, sort by their index
            return indexA - indexB;
          });

          if (this.$store.cartDrawerStore.isSubscriptionActive && this.sellingPlan !== null) {
            this.$store.cartDrawerStore.setSellingPlan(this.getDefaultSellingPlan());

            if (this.cartProducts.length > 0) {
              this.updateCartItems();
            }
          }
        },

        /**
         * Format price in currency
         * @param {number} amount - Amount in cents
         * @returns {string}
         */
        formatMoney(amount) {
          if (amount == null || isNaN(amount)) return "£0.00";

          // Convert cents to pounds
          const value = amount / 100;

          return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
          }).format(value);
        },

        /**
         * Displays the notification.
         */
        displayNotification() {
          // @ts-ignore
          if (!window.cartNotificationsParams) return;
          // @ts-ignore
          const params = window.cartNotificationsParams;
  
          if (!params.enable) return;
  
          // @ts-ignore
          window.Toastify({
            text: params.text,
            duration: params.duration,
            className: 'ctr-toastify-notification',
            newWindow: true,
            close: true,
            gravity: params.positionY, 
            position: params.positionX, 
            stopOnFocus: true,
            offset: {
              x: params.offsetX,
              y: params.offsetY,
            },
            style: {
              background: params.background,
              color: params.textColor
            },
          }).showToast();
        }
    };
  });
});